<template>
  <div class="min-h-screen px-6 py-8 md:px-10">
    <div class="w-full space-y-6">

      <!-- HEADER -->
      <div>
        <h1 class="mt-2 text-3xl text-gray-900">
          Relatório Meireles
        </h1>
        <p class="mt-2 max-w-2xl text-sm text-gray-500">
          Consulte os dados de envio, operadores e valores por cliente.
        </p>
      </div>

      <!-- FILTROS -->
      <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div class="p-6">
          <form @submit.prevent="start">
            <div class="grid grid-cols-1 gap-4 md:grid-cols-3">

              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium text-gray-500">
                  A partir de
                </label>
                <input
                  v-model="form.de"
                  type="datetime-local"
                  class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                />
              </div>

              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium text-gray-500">
                  Até
                </label>
                <input
                  v-model="form.ate"
                  type="datetime-local"
                  class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                />
              </div>

              <div class="flex items-end">
                <button
                  type="submit"
                  class="h-11 w-full rounded-xl font-medium text-white transition"
                  :style="{ backgroundColor: primaryColor }"
                  @mouseenter="$event.target.style.backgroundColor = mixPrimaryColor('#111827', 0.2)"
                  @mouseleave="$event.target.style.backgroundColor = primaryColor"
                >
                  Gerar relatório
                </button>
              </div>

            </div>
          </form>
        </div>
      </div>

      <!-- TOTAL -->
      <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
        <span class="text-sm font-medium text-gray-500">Total</span>
        <p class="mt-2 text-3xl text-green-700">
          {{ formatPrice(total_tarifa) }}
        </p>
      </div>

      <!-- TABELA -->
      <div class="w-full overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div class="overflow-x-auto">
          <table class="w-full min-w-max text-sm">

            <thead class="border-b bg-gray-100 text-gray-600">
              <tr>
                <th class="px-6 py-4 text-left">Cliente</th>
                <th class="px-6 py-4 text-left">Produto</th>
                <th class="px-6 py-4 text-left">Rota</th>
                <th class="px-6 py-4 text-left">Cobrança</th>
                <th class="px-6 py-4 text-left">Saldo</th>
                <th class="px-6 py-4 text-left">Limite</th>
                <th class="px-6 py-4 text-left">Envio</th>
                <th class="px-6 py-4 text-left">Conversas</th>
                <th class="px-6 py-4 text-left">Op. Tarifados</th>
                <th class="px-6 py-4 text-left">Op. Totais</th>
                <th class="px-6 py-4 text-left">Total</th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="el in data"
                :key="el._id"
                class="border-b border-gray-100 hover:bg-slate-50"
              >
                <td class="px-6 py-5">
                  <div class="flex items-center gap-3">
                    <div class="h-10 w-10 rounded-xl bg-blue-50 flex items-center justify-center text-blue-700 font-semibold">
                      {{ (el.clienteNome || '').slice(0,2).toUpperCase() }}
                    </div>
                    <span class="font-medium text-gray-800">
                      {{ el.clienteNome || '-' }}
                    </span>
                  </div>
                </td>

                <td class="px-6 py-5">{{ el.produto || '-' }}</td>
                <td class="px-6 py-5">{{ el.rota || '-' }}</td>
                <td class="px-6 py-5">{{ el.tipoCobranca || '-' }}</td>
                <td class="px-6 py-5">{{ el.saldoPrePago || 0 }}</td>
                <td class="px-6 py-5">{{ el.limiteMensal || 0 }}</td>
                <td class="px-6 py-5">{{ el.entregues_enviados || 0 }}</td>
                <td class="px-6 py-5">{{ el.conversas_retornos || 0 }}</td>
                <td class="px-6 py-5">{{ el.qtdOperador || 0 }}</td>
                <td class="px-6 py-5">{{ el.totalOperadores || 0 }}</td>

                <td class="px-6 py-5 font-semibold text-green-700">
                  {{ el.total || 0 }}
                </td>
              </tr>

              <!-- EMPTY -->
              <tr v-if="data.length === 0">
                <td colspan="11" class="text-center py-12 text-gray-400">
                  Nenhum dado encontrado
                </td>
              </tr>
            </tbody>

          </table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from "moment";
import { colorMixin } from '@/utils/colorMixin';

export default {
  mixins: [colorMixin],
  data() {
    return {
      moment,
      data: [],
      form: {
        de: moment().startOf("month").format("YYYY-MM-DDTHH:mm"),
        ate: moment().endOf("month").format("YYYY-MM-DDTHH:mm"),
      },
      total_tarifa: 0
    };
  },

  methods: {
    formatPrice(value) {
      return Number(value || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });
    },

    async start() {
      const de = moment(this.form.de).startOf("month").format("YYYY-MM-DDTHH:mm");
      const ate = moment(this.form.ate).endOf("month").format("YYYY-MM-DDTHH:mm");

      const listReq = await this.$http.get(`/relatorio-meireles?de=${de}&ate=${ate}`);

      this.data = listReq.data.data || [];
      this.total_tarifa = listReq.data.total_tarifa || 0;
    }
  },

  async beforeMount() {
    await this.start();
  }
};
</script>